import { Pipe, PipeTransform } from '@angular/core';
import {FiltersListService} from '@app/views/admin/application-settings/components/filters/filters-list-wrapper/filters-list.service';
import {GradeMap} from '@app/core/model/grade.map';

@Pipe({
    name: 'gradeFriendlyValue'
})
export class GradeFriendlyValuePipe implements PipeTransform {

    transform(value: string, propertyName: string): any {
        const isGrade = FiltersListService.checkIsGradeSelected(propertyName);
        if (isGrade) {
            if (value && Array.isArray(value)) {
                return value.map((grade: string) => this.getGradeTitle(grade));
            } else {
                return this.getGradeTitle(value);
            }
        }

        return value;
    }

    getGradeTitle(value: string): string {
        return (value && GradeMap.has(value)) ? GradeMap.get(value) : value;
    }
}
